import { Outlet } from 'react-router-dom';
import { useSelector } from 'store';

import Breadcrumbs from 'components/@extended/Breadcrumbs';

import navigation from 'menu-items';
import { Box, Container } from '@mui/material';
import ScrollTop from 'components/ScrollTop';
import { DRAWER_WIDTH } from 'config';

// ==============================|| MAIN LAYOUT ||============================== //

const GuestLayout = () => {
  const { container } = useSelector(({ config }) => config);

  return (
    <ScrollTop>
      <Box sx={{ display: 'flex', width: '100%' }}>
        <Box
          component="main"
          sx={{
            width: `calc(100% - ${DRAWER_WIDTH}px)`,
            minHeight: '100vh',
            maxHeight: { xs: '100vh' },
            overflowY: 'auto',
            flexGrow: 1,
            p: { xs: 2, lg: 4 },
            borderTop: { xs: '1px solid #DDDDDD', lg: 'none' }
          }}
        >
          <Container
            maxWidth={container ? 'xl' : false}
            sx={{
              px: '0 !important',
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              height: { md: '100%' }
            }}
          >
            <Breadcrumbs navigation={navigation} title titleBottom card={false} divider={false} guest />
            <Outlet />
          </Container>
        </Box>
      </Box>
    </ScrollTop>
  );
};

export default GuestLayout;
